<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useOutStateModelStore} from "@/stores/OutStateModel";
import axios from "axios";

export default {
    props: {
        value: Number,
        type: String,
        rules: Array,
        readonly: Boolean,
        label: String,
    },
    setup(props) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const outStateModelStore = useOutStateModelStore();

        const outStateModel = ref(null);


        function findAll() {
            loading.value = true;
            axios.get(`/outStateModels/type`, {
                params: {
                    type: props.type,
                },
            }).then((response) => {
                outStateModelStore.setOutStateModels(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => props.value, () => {
            outStateModel.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            loading,
            inputColor,
            backgroundColor,
            outStateModel,
            outStateModelStore,
        }
    },
};
</script>

<template>
    <div>
        <v-autocomplete
                v-model="outStateModel"
                :label="label"
                :items="outStateModelStore.outStateModels"
                item-value="id"
                item-text="name"
                outlined
                dense
                :clearable="!readonly"
                :readonly="readonly"
                :loading="loading"
                :color="inputColor"
                :background-color="backgroundColor"
                hide-details="auto"
                @input="$emit('input', outStateModel)"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>